import { writable, get } from "svelte/store";
import { TopicService } from "$/services/TopicService";
import { BackgroundService } from "$/services/BackgroundService";
let TopicServiceImpl = (chrome === null || chrome === void 0 ? void 0 : chrome.storage) ? BackgroundService : TopicService;
const store = () => {
    const { subscribe, set, update } = writable(new Map());
    return {
        subscribe,
        set,
        update,
        // Set or update a highlight
        setHighlight: (id, top, left, width, height, group, url, content, highlight, originalId) => {
            update((highlights) => {
                highlights.set(id, {
                    id,
                    top,
                    left,
                    width,
                    height,
                    group,
                    url,
                    content,
                    highlight,
                    originalId,
                });
                return highlights;
            });
        },
        // Retrieve a highlight by its ID
        getHighlight: (id) => {
            return get(HighlightStore).get(id);
        },
        // Remove a highlight by its ID
        deleteHighlight: (id) => {
            update((highlights) => {
                highlights.delete(id);
                return highlights;
            });
        },
        // Retrieve all highlights
        getAllHighlights: () => {
            return Array.from(get(HighlightStore).values());
        },
        // Check if a highlight exists by its ID
        hasHighlight: (id) => {
            return get(HighlightStore).has(id);
        },
        // Clear all highlights
        clearAllHighlights: () => {
            set(new Map());
        },
        // Clear highlights by group
        clearHighlightsByGroup: (group) => {
            update((highlights) => {
                Array.from(highlights.entries()).forEach(([id, highlight]) => {
                    if (highlight.group === group) {
                        highlights.delete(id);
                    }
                });
                return highlights;
            });
        },
    };
};
export const HighlightStore = store();
